import React from 'react';
import style from './SideDrawer.module.scss';

const SideDrawer = ({ isOpen, onRequestClose , from, children, width, height, top, customClasses}) => {
    const drawerClasses = [
        from === 'right' ? style.sidedrawerRight : style.sidedrawerLeft,
        isOpen && style.open,
        customClasses,
      ].filter(Boolean);
      
  return (
      <div>
         {isOpen && <Backdrop onBackDropClose={onRequestClose}/>}
          <div className={drawerClasses.join(' ')} style={{ width: width, height:height, top:top }}>
              {children}
         </div>
      </div>
  )
}

export default SideDrawer;

const Backdrop = ({ onBackDropClose }) => {
    return (
        <div className={style.backdrop} onClick={onBackDropClose}></div>
    )
}